// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image__container-a1a797 {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background-color: var(--base-17);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Payloads/Image/styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n  border-radius: 16px;\n  overflow: hidden;\n  background-color: var(--base-17);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Image__container-a1a797`
};
module.exports = ___CSS_LOADER_EXPORT___;
